import React, { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import {
  setMultiTenancyConfigData,
  setAffiliateLoading,
} from "../redux/modules/multiTenancyConfig";
import config from "../clientConfig";
import { LoadingStripe } from "./loading";

type WidgetProps = {
  widgetConfig?: {
    frameKey?: string;
    [key: string]: any;
  };
  children?: React.ReactNode;
};

/** Stable axios instance */
const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

const StyleConfiguration: React.FC<WidgetProps> = ({
  widgetConfig,
  children,
}) => {
  const [affiliateConfig, setAffiliateConfig] = useState<any>(null);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { AffiliateLoading } = useAppSelector((state) => ({
    AffiliateLoading: state.affiliate.AffiliateLoading,
  }));

  /** Fetch Affiliate Configuration */
  const fetchAffiliateConfig = async (signal?: AbortSignal) => {
    dispatch(setAffiliateLoading(true));
    try {
      const response = await axiosInstance.get(
        "/Affiliate/GetAffiliateConfiguration",
        {
          signal,
          headers: {
            apiKey: config.apiKey,
          },
        },
      );

      const data = response.data;

      if (data.responsetype === "error") {
        dispatch(setAffiliateLoading(false));
        navigate("/notfound");
        return;
      }
      localStorage.setItem("affiliateId", data?.affiliateId || "");
      dispatch(setMultiTenancyConfigData(data));
      setAffiliateConfig(data);
      dispatch(setAffiliateLoading(false));

      if (!data.isActive) {
        navigate("/domain-deactivated");
      }
    } catch (err) {
      if (axios.isCancel(err)) return;

      if (err instanceof AxiosError) {
      } else if (err instanceof Error) {
      } else {
      }

      dispatch(setAffiliateLoading(false));
      console.error("fetchAffiliateConfig:", err);
    }
  };

  /** Run ONCE */
  useEffect(() => {
    const controller = new AbortController();

    fetchAffiliateConfig(controller.signal);

    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Dynamic CSS */
  const styleConfiguration = `
    :root {
      --dynamicPrimaryColor: ${affiliateConfig?.primaryColourCode || "#000"};
      --dynamicSecondaryColor: ${
        affiliateConfig?.secondaryColourCode || "#000"
      };
      --dynamicNavBarColor: ${affiliateConfig?.defaultColourCode || "#000"};
    }
  `;

  /** Loader */
  if (AffiliateLoading) {
    return <LoadingStripe />;
  }

  return (
    <>
      <style>{styleConfiguration}</style>
      {children}
    </>
  );
};

export default StyleConfiguration;
